import React, { Component } from 'react';
import config from 'react-global-configuration';

// config.set({
// 	url: 'http://localhost:5000',
// 	auth: 'http://sigvoos.test',
// 	api: 'http://sigvoos.test/api',
// 	cdn: 'http://sigvooscdn.test',
// 	refresh_time: 20,
// 	development: 1
// });

// Produção
config.set({
	url: 'https://www.sigvoos.com.br',
	auth: 'https://api.sigvoos.com.br',
	api: 'https://api.sigvoos.com.br/api',
	cdn: 'https://cdn.sigvoos.com.br',
	api_sigmec: 'https://api.sigvoos.com.br/api',
	cdn_sigmec: 'https://cdn.sigvoos.com.br',
	api_sigtrein: 'https://api.sigvoos.com.br/api',
	cdn_sigtrein: 'https://cdn.sigvoos.com.br',
	development: false,
	refresh_time: 20
});

class Globals extends Component {
}

export default Globals;



// WEBPACK FOOTER //
// ./src/Components/Miscelania/Globals.js